<script>
export default {
  mounted() {
    if (this.$route.query.redirect_url) {
      window.location.href = this.$route.query.redirect_url;
    } else {
      this.$router.replace('/login').catch(() => {});
    }
  },
};
</script>
